// Format Number Data Container Tab
export function formatNumber(input) {
  const str = input.toString();
  const parts = [];
  let i = str.length;
  while (i > 0) {
    parts.unshift(str.substring(Math.max(0, i - 3), i));
    i -= 3;
  }
  return parts.join('.');
}
export function formatQueryString(payload) {
  let queryString = '?';
  for (const key in payload) {
    if (payload.hasOwnProperty(key)) {
      const value = payload[key];
      if (Array.isArray(value)) {
        queryString += `${key}=${value.join(',')}&`;
      } else if (typeof value === 'object') {
        queryString += `${key}=${JSON.stringify(value)}&`;
      } else {
        queryString += `${key}=${value}&`;
      }
    }
  }
  return queryString.slice(0, -1); // Remove the trailing '&'
}
